export default __webpack_public_path__ + "static/featurePhone2-82e34d1b253ab21eb4d38132fad62a2c.png";